import { getEventTransfer } from 'slate-react';
import isInEmbedPlaceholder from '../utils/isInEmbedPlaceholder';
import setEmbedType from '../utils/setEmbedType';
import { WhiteListedForIntegrationSuggestion } from '../../../types/EmbeddableTypes';
export default function makeOnPasteHandler() {
  var getApplications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return null;
  };

  /**
   * User is pasting content, insert it as embed
   */
  return function onPaste(event, editor, next) {
    var applications = getApplications().filter(function (application) {
      return application.isInstalled && application.integration;
    });

    if (!applications) {
      return next();
    }

    var value = editor.value;
    var data = getEventTransfer(event);

    if (!value.selection.isCollapsed) {
      return next();
    }

    var inEmbedPlaceholder = isInEmbedPlaceholder(value); // Inside embed placeholder ?

    if (!inEmbedPlaceholder) {
      return next();
    } // Convert to text if needed


    var text;

    if (data.type === 'fragment') {
      text = data.fragment.getTexts().map(function (t) {
        return t.text;
      }).join('');
    } else {
      text = data.text;
    }

    try {
      var matchingApplication = applications.find(function (_ref) {
        var integration = _ref.integration;
        var found = integration.unfurlPatterns.find(function (pattern) {
          var regexp = new RegExp(pattern);
          return regexp.test(text || '');
        });
        return Boolean(found);
      });

      if (!matchingApplication) {
        return next();
      }

      var embedType = matchingApplication.name.toLowerCase();

      if (!WhiteListedForIntegrationSuggestion.includes(embedType)) {
        return next();
      }

      return setEmbedType(editor, editor.value.startBlock, embedType).insertText(text);
    } catch (error) {
      return next();
    }
  };
}